import { FC } from 'react'

import { NodeProps, Position } from '@xyflow/react'

import {
  EditorNodeTemplate,
  NodeHandle
} from 'Automations/nodeDefinitions/components'
import {
  APPROVED_HANDLE_ID,
  APPROVED_HANDLE_LABEL,
  REJECTED_HANDLE_ID,
  REJECTED_HANDLE_LABEL
} from './review.constants'

export const ReviewEditorNode: FC<NodeProps> = ({ id, selected }) => {
  return (
    <EditorNodeTemplate nodeId={id} minWidth="133px" selected={selected}>
      <EditorNodeTemplate.Rows>
        <EditorNodeTemplate.Row>
          <EditorNodeTemplate.Row.Text>
            {APPROVED_HANDLE_LABEL}
          </EditorNodeTemplate.Row.Text>
          <NodeHandle
            nodeId={id}
            handleMapping={APPROVED_HANDLE_ID}
            type="source"
            position={Position.Right}
            selected={selected}
            insideRow
          />
        </EditorNodeTemplate.Row>

        <EditorNodeTemplate.Row>
          <EditorNodeTemplate.Row.Text>
            {REJECTED_HANDLE_LABEL}
          </EditorNodeTemplate.Row.Text>
          <NodeHandle
            nodeId={id}
            handleMapping={REJECTED_HANDLE_ID}
            type="source"
            position={Position.Right}
            selected={selected}
            insideRow
          />
        </EditorNodeTemplate.Row>
      </EditorNodeTemplate.Rows>

      <NodeHandle
        nodeId={id}
        type="target"
        position={Position.Left}
        selected={selected}
      />
    </EditorNodeTemplate>
  )
}
